import I18n from 'i18n-js'

// @ts-ignore
I18n.fallbacks = true
// @ts-ignore
I18n.locale = gon.locale
// @ts-ignore
if (window.I18n) {
  // @ts-ignore
  Object.assign(I18n.translations, window.I18n.translations)
}
// @ts-ignore
window.I18n = I18n
